
export * from './import-img.component';
export * from './import-img.module';